module.exports = __webpack_public_path__ + "img/image-file.7008518f.png";